<script>
import Chart from 'chart.js'
import { generateChart } from 'vue-chartjs'
import { Line } from 'vue-chartjs'

Chart.defaults.LineWithLine = Chart.defaults.line;
Chart.controllers.LineWithLine = Chart.controllers.line.extend({
    name: "LineWithLine",
    initialize: function(chart, datasetIndex) {
      Chart.controllers.line.prototype.initialize.apply(this, arguments);

    },
    draw: function(ease) {
      // Chart.controllers.Line.prototype.draw.apply(this, arguments);

      // var point = this.datasets[0].points[this.options.lineAtIndex]
      // var scale = this.scale

      // // draw line
      // this.chart.ctx.beginPath();
      // this.chart.ctx.moveTo(point.x, scale.startPoint + 24);
      // this.chart.ctx.strokeStyle = '#ff0000';
      // this.chart.ctx.lineTo(point.x, scale.endPoint);
      // this.chart.ctx.stroke();

      // // write TODAY
      // this.chart.ctx.textAlign = 'center';
      // this.chart.ctx.fillText("TODAY", point.x, scale.startPoint + 12);
    },
    setHoverStyle: function(element) {
      console.log(element._xScale.top)
      // console.log(this.scale)
      // console.log(this.datasets[0].points)
      // console.log(this.options.lineAtIndex)
    }
});

const CustomLine = generateChart('custom-line', 'LineWithLine')

export default {
  extends: Line,//CustomLine
  props: ['userAccessByDay'],
  computed: {
    chartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            label: this.$t('Analysis.User.male'),
            borderColor: '#009CE1',
            borderWidth: 1.5,
            backgroundColor: '#009CE1',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#009CE1',
            data: this.countsForGender('male')
          },
          {
            label: this.$t('Analysis.User.female'),
            borderColor: '#66C4ED',
            borderWidth: 1.5,
            backgroundColor: '#66C4ED',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#66C4ED',
            data: this.countsForGender('female')
          },
          {
            label: this.$t('Analysis.User.other'),
            borderColor: '#EEEEEE',
            borderWidth: 1.5,
            backgroundColor: 'rgba(0,0,0,0.1)',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: 'rgba(0,0,0,0.1)',
            data: this.countsForGender('other')
          }
        ]
      };
    },
    labels: function() {
      return Object.keys(this.userAccessByDay).sort();
    },
    totalCounts() {
      return this.labels.map(date => {
        let total = 0;
        for (let gender of [ 'male', 'female', 'other', '_unknown' ]) {
          const counts = this.userAccessByDay[date][gender] || { };
          total += Object.values(counts).reduce((a,v)=>a+v,0);
        }
        return total;
      });
    }
  },
  mounted() {
    this.options = {
      plugins: {
        datalabels: {
          display: false
        }
      },
      tooltips: {
        mode: 'x-axis',
        intersect: false,
        position: 'nearest'
      },
      hover: {
        mode: 'x-axis',
        intersect: false
      },
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          gridLines: {
            display: false
          },
          ticks: {
            fontColor: "#999"
          }
        }],
        yAxes: [{
          stacked: true,
          ticks: {
            max: 100,
            fontColor: "#999"
          }
        }]
      },
      maintainAspectRatio: false,
      elements: {
        line: {
          tension: 0
        }
      }
    };
    this.renderChart(this.chartData, this.options);
  },
  methods: {
    countsForGender: function(gender) {
      return this.labels.map(date => {
        const counts = this.userAccessByDay[date][gender] || { };
        let count = Object.values(counts).reduce((a,v)=>a+v,0);
        if (gender === 'other') {
            const unknownCounts = this.userAccessByDay[date]['_unknown'] || { };
            count += Object.values(unknownCounts).reduce((a,v)=>a+v,0);
        }
        return count;
      }).map((val, index) => this.totalCounts[index] !== 0 ? (val / this.totalCounts[index] * 100) : 0)
        .map(val => Math.round(val * 10) / 10);
    }
  },
  watch : {
    userAccessByDay: function() {
      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>
